import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../../../../../components/checkbox';
import { Header } from '../../../../../../../../components/header';
import { useMeterConfigurationContext } from '../../context';

export const ActionPartForm: React.FC = () => {
  const { t } = useTranslation('channel-details');
  const { activeRuleIndex, form } = useMeterConfigurationContext();

  return (
    <>
      <Header title={t('meterConfiguration.action.actionLabel')} />
      <Controller
        name={`rules.${activeRuleIndex}.isDefaultAction`}
        control={form.control}
        render={({ field }) => (
          <Checkbox checked={field.value} reverse onChange={field.onChange}>
            {t('meterConfiguration.action.defaultAction')}
          </Checkbox>
        )}
      />
      <Controller
        name={`rules.${activeRuleIndex}.isNotifyAction`}
        control={form.control}
        render={({ field }) => (
          <Checkbox checked={field.value} reverse onChange={field.onChange}>
            {t('meterConfiguration.action.notification')}
          </Checkbox>
        )}
      />
    </>
  );
};
